import { FrameFeatureCollection2 } from "../framefeaturetree/internal";
import { Obj } from "../internal";
import { FeatureStyle, FeatureCollection } from "./internal";
/**
 * Handles all FeatureCollections
 * @class FeatureHandler
 * @extends Obj
 * @constructor
 */
export class FeatureHandler extends Obj {
    constructor(scene) {
        super();
        this.featurecollections = [];
        this.pick_x = 0;
        this.pick_y = 0;
        this.pickedfeatures = [];
        this.parentscene = scene;
    }
    /**
     * Creates a new FeatureCollection and puts it in the featurecollecion-Array.
     *
     * @param {FeatureStyle=} styledef The style definition object
     * @param {FeatureStyle=} highlightstyledef The highlightstyle definition object
     * @param {string=} name The name of the FeatureCollection
     * @param {boolean=}  pickeable set this to false if all features in this collection shouldn't be pickable
     * @param {boolean=} framefeature set true to create a FrameFeatureCollection2 (extension of the basic FrameFeatureCollection).
     * @return {FeatureCollection}
     */
    createFeatureCollection(styledef, highlightstyledef, name = "", pickeable = true, framefeature = false) {
        let featureCollection;
        if (framefeature) {
            featureCollection = new FrameFeatureCollection2(this.parentscene, styledef, highlightstyledef, name, pickeable, this);
        }
        else {
            featureCollection = new FeatureCollection(this.parentscene, styledef, highlightstyledef, name, pickeable, this);
        }
        this.featurecollections.push(featureCollection);
        return featureCollection;
    }
    removeFeatureCollection(fc) {
        let index = -1;
        for (let i = 0; i < this.featurecollections.length; i++) {
            if (this.featurecollections[i] == fc) {
                this.featurecollections[i].destroy();
                index = i;
            }
        }
        if (index >= 0)
            this.featurecollections.splice(index, 1);
    }
    /**
     * update -  update all feature collections...
     * @method update
     */
    update() {
        for (let i = 0; i < this.featurecollections.length; i++) {
            this.featurecollections[i].update();
        }
    }
    /**
     * Creates a FeatureCollection from a json string or json object
     * @method parseFromGeoJSON
     * @param {Object|string} geojson
     * @param {FeatureStyle=} style Optional. The Style of the Feature-Collection. If not specified the default-style is used.
     * @param {FeatureStyle=} highlightstyle Optional. The Highlight-Style of the FeatureCollection. If not specified the default-style is used.
     * @param {string=} name Optional. The name of the FeatureCollection.
     * @param {boolean=} pickeable Optional. Set this to false if all features in this collection shouldn't be pickable
     * @return {?FeatureCollection}
     */
    parseFromGeoJSON(geojson, style, highlightstyle, name, pickeable) {
        let new_fc = null;
        let geoobject = null;
        if (typeof geojson == typeof String()) {
            geoobject = JSON.parse(geojson);
        }
        else {
            geoobject = geojson;
        }
        if (geoobject["type"] == "FeatureCollection") {
            new_fc = this.createFeatureCollection(style, highlightstyle, name, pickeable);
            new_fc.parseFromJSON(geoobject);
        }
        return new_fc;
    }
    /**
     * Creates a GeoJson-String containing all featureCollections handled by FeatureHandler
     * @method toGeoJsonString
     * @return {string}
     */
    toGeoJsonString() {
        let jsonstring = "[";
        for (let i = 0; i < this.featurecollections.length; i++) {
            jsonstring += this.featurecollections[i].toGeoJsonString();
            if (i < this.featurecollections.length - 1)
                jsonstring += ",";
        }
        jsonstring += "]";
        return jsonstring;
    }
    /**
     * Pick-Function. Returns the Pickdata-Object from the given mouse-coordinates.
     * @method pick
     * @param {number} mx
     * @param {number} my
     * @param {FeatureCollection=} picklayers
     * @return {?Object}
     */
    pick(mx, my, picklayers) {
        this.pick_x = mx;
        this.pick_y = my;
        const pickedfeatures = [];
        if (picklayers) {
            for (let i = 0; i < picklayers.length; i++) {
                if (picklayers[i].pickable)
                    picklayers[i].pick(mx, my, pickedfeatures);
            }
        }
        else {
            for (let i = 0; i < this.featurecollections.length; i++) {
                if (this.featurecollections[i].pickable)
                    this.featurecollections[i].pick(mx, my, pickedfeatures);
            }
        }
        if (pickedfeatures.length == 0)
            return null;
        pickedfeatures.sort(function (a, b) {
            return a.mindist - b.mindist;
        });
        return pickedfeatures;
    }
    /**
     * Snap-Function. Returns the Pickdata-Object from the given mouse-coordinates the layer to snap on.
     * @param {number} mx
     * @param {number} my
     * @param {any} snaplayer
     * @return {?Object}
     */
    snap(mx, my, snaplayer) {
        this.pick_x = mx;
        this.pick_y = my;
        const pickeddata = [];
        if (snaplayer) {
            if (snaplayer instanceof Array) {
                for (let i = 0; i < snaplayer.length; i++) {
                    snaplayer[i].pick(mx, my, pickeddata);
                }
            }
            else {
                snaplayer.pick(mx, my, pickeddata);
            }
        }
        else {
            for (let i = 0; i < this.featurecollections.length; i++) {
                this.featurecollections[i].pick(mx, my, pickeddata);
            }
        }
        if (pickeddata == null)
            return null;
        pickeddata.sort(function (a, b) {
            return a.mindist - b.mindist;
        });
        return pickeddata;
    }
    highlightOff() {
        for (let i = 0; i < this.featurecollections.length; i++) {
            const fc = this.featurecollections[i];
            if (!fc.pickable)
                continue;
            fc.highlightOff();
        }
    }
    /**
     * Creates a new FeatureStyle object
     *
     * @param {string} name Stylename
     * @param {Object|null} styledef style definitions
     * @return {FeatureStyle}
     */
    createFeatureStyle(name, styledef) {
        const featureStyle = new FeatureStyle(styledef);
        featureStyle.stylename = name;
        return featureStyle;
    }
}
//# sourceMappingURL=featurehandler.js.map